import { BaseDao } from './BaseDao';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs';

export class FailedMutationDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.FAILEDMUTATION, apiHelper);
  }

  // public getKeywordsById(keyIds, adGroupId, customerId): Observable<any> {
  //   let url = this.apiHelper.getServiceName() + 'adwords/keysById?integrationId=' + customerId;
  //   let headers = this.apiHelper.getDefaultHeader();
  //
  //   let data = [];
  //   for (let i = 0; i < keyIds.length; i += 500) {
  //     data.push({
  //       keywordIds: keyIds.slice(i, i + 500),
  //       adGroupId: adGroupId
  //     });
  //   }
  //
  //   return new Observable(observer => {
  //     let sum = [];
  //     for (let i = 0; i < data.length; ++i) {
  //       let httpRequest = this.apiHelper.apiCall(url, 'POST', null, data[i], headers, null, null, null);
  //       httpRequest.subscribe(
  //         (res: any) => {
  //           res.entries.forEach(entry =>
  //             sum.push({
  //               id: entry.criterion.id,
  //               text: entry.criterion.text
  //             })
  //           );
  //           if (sum.length === keyIds.length) {
  //             observer.next(sum);
  //             observer.complete();
  //           }
  //         },
  //         err => observer.error(err)
  //       );
  //     }
  //   });
  // }
}
